import { render, staticRenderFns } from "./CountriesForm.vue?vue&type=template&id=5205a426&"
import script from "./CountriesForm.vue?vue&type=script&lang=js&"
export * from "./CountriesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports